<script lang="ts">
  import { closeModal } from "@thehood/svlib";

  export let isOpen: boolean;
  export let message: string;
  export let title: string;
  export let yesText: string = "OK";
  export let noText: string = "Cancel";
  export let onCloseCallback: () => void = () => {
    // console.log("empty");
  };
  export let onConfirm: () => void | Promise<void> = () => {};

  function handleClose(ev: Event) {
    ev.stopImmediatePropagation();
    onCloseCallback();
    closeModal();
  }

  function accept(ev: Event) {
    handleClose(ev);
    onConfirm();
  }
</script>

{#if isOpen}
  <div role="dialog" class="modal">
    <div class="contents">
      <h2>{title}</h2>
      <p>{@html message}</p>
      <div class="actions">
        <button class="btn secondary" on:click={handleClose}>{noText}</button>
        <button class="btn btn-primary" on:click={accept}>{yesText}</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z5);
    /* allow click-through to backdrop */
    pointer-events: none;
  }

  .contents {
    min-width: 240px;
    border-radius: 6px;
    padding: 16px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    pointer-events: auto;
  }

  h2 {
    text-align: center;
    font-size: 24px;
  }

  p {
    text-align: center;
    margin-top: 16px;
  }

  .actions {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
</style>
